import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {updateSourceFiles} from "../../redux/reducers/SourceFilesSlice";
import CustomProgressBar from "./CustomProgressBar";
import $ from "jquery";
import axios from "axios";
import {FileIcon, UploadIcon, ZipfileIcon} from "../../AppIcons";
import Constants from "../../Constants";

const FileDragUpload = React.forwardRef((props, ref) => {

    const [selectedfile, setSelectedFile] = useState("");
    const [files, setFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(null);
    const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
    const chunkSize = Constants.CHUNK_SIZE;
    const [isUploading, setIsUploading] = useState(false)

    const dispatch = useDispatch();
    const sourceFiles = useSelector(
        (reduxStore) => reduxStore.source_files
    ).value;
    const totalChunks = useRef(0);


    useEffect(() => {
        if (currentFileIndex !== null) {
            setCurrentChunkIndex(0);
        }
    }, [currentFileIndex]);

    useEffect(() => {
        if (currentChunkIndex !== null) {
            readAndUploadCurrentChunk();
        }
    }, [currentChunkIndex]);

    function reset() {
        setSelectedFile("")
        setFiles([]);
        setCurrentFileIndex(null)
        setCurrentChunkIndex(null);
        setIsUploading(false);
    }

    function startUpload() {
        let fileIndex = 0;
        setCurrentFileIndex(fileIndex);
        setIsUploading(true)
        totalChunks.current = Math.ceil(selectedfile.size / chunkSize)
        dispatch(
            updateSourceFiles([
                ...sourceFiles,
                selectedfile.name.replaceAll(" ", "_"),
            ])
        )
    }

    useImperativeHandle(ref, () => ({
        startUpload, reset
    }), [startUpload, reset]);

    function fileSelection(e) {
        if (e.target) {
            setSelectedFile(e.target.files[0]);
            setFiles((files) => [...files, selectedfile]);
            if (props.onChange) {
                props.onChange(e);
            }
        }
    }

    const clearValue = (e) => {
        e.target.value = null
    }

    function readAndUploadCurrentChunk() {
        const reader = new FileReader();
        const from = currentChunkIndex * chunkSize;
        const to = from + chunkSize;
        const blob = selectedfile.slice(from, to);
        reader.onload = (e) => uploadChunk(e);
        reader.readAsDataURL(blob);
    }

    function uploadChunk(readerEvent) {
        $('.progressReport').trigger('focus');
        let params = {
            name: selectedfile.name,
            size: selectedfile.size,
            currentChunkIndex: currentChunkIndex,
            totalChunks: totalChunks.current,
            fileDataAttribute: props.fileDataAttribute ? props.fileDataAttribute : "attachment.fileData",
            "attachment.filename": selectedfile.name
        };
        params = {...params, ...(props.getUploadParams && props.getUploadParams() || {})}

        const urlParams = new URLSearchParams(params);
        const headers = {
            "Content-Type": "application/octet-stream",
            "CSRF-Token": localStorage.getItem("csrfToken")
        };
        let url = props.uploadUrl;
        if (!url.includes("/upload")) {
            url = "/upload" + url;
        }
        url = process.env.REACT_APP_BACKEND_SERVER + url + "?" + urlParams.toString();
        axios.post(url, readerEvent.target.result, {headers}).then((response) => {
            $("#files").trigger('focus');
            const isLastChunk = currentChunkIndex === totalChunks.current - 1;
            if (isLastChunk) {
                setIsUploading(false)
                setCurrentChunkIndex(null);
                setCurrentFileIndex(null);
                setFiles(files.filter((fileInfo) => fileInfo.name !== selectedfile.name));
                if (props.uploadEndHandler) {
                    props.uploadEndHandler(response)
                }
            } else {
                setCurrentChunkIndex(currentChunkIndex + 1);
            }
        });
    }

    return (
        <div style={{'textAlign': 'center'}}>
            <div className="upload-icon">
                {UploadIcon}
            </div>
            {props.children}
            <div className="input-file-container">
                <div className="input-file-container">
                    <div className="input-file">
                        <input
                            type="file"
                            id="files"
                            className="file_upload first-focus"
                            disabled={isUploading}
                            onChange={fileSelection}
                            onClick={clearValue}
                            aria-labelledby="uploadError"
                        />
                        <label className="file-button " htmlFor="files">
                            {selectedfile === "" ? "Choose file" : "Replace file"}
                        </label>
                    </div>

                    <div className="gb-upload-files files">
                        {files.map((file, fileIndex) => {
                            let progress = 0;
                            if (isUploading) {
                                const uploading = fileIndex === currentFileIndex;
                                const chunks = Math.ceil(selectedfile.size / chunkSize);
                                if (uploading) {
                                    progress = Math.round((currentChunkIndex / chunks) * 100);
                                } else {
                                    progress = 0;
                                }
                                if (chunks === 1) {
                                    progress = 50;
                                }
                            }
                            return (
                                <div className="show-flex flex-center multiple-files">
                                    <div className="icon-block">
                                        {FileIcon}
                                    </div>
                                    <div className="right-progressbar">
                                        <label>{file.name}</label>
                                        <CustomProgressBar
                                            completed={progress !== "" ? progress : 0}
                                            labelLineHeight="1px"
                                            labelSize="14px"
                                            width="100%"
                                            labelClassName="progressBarLabel"
                                            borderRadius="30px"
                                            labelAlignment="outside"
                                            labelColor="rgba(0,0,0,0.87)"
                                            height="6px"
                                            className="campaign_progress"
                                            bgColor="#06B878"
                                            baseBgColor="#D1DEF0"
                                            ariaValuetext={progress !== "" ? progress : 0}
                                            aria-label=""
                                            aria-valuenow={progress !== "" ? progress : 0}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="upload-file-ext flex-center">
                        <div className="inline-flex">
                            <strong className={selectedfile ? "show-flex" : "hide"}>
                                {ZipfileIcon}
                            </strong>
                            <span>{selectedfile?.name}</span>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
});

export default FileDragUpload;